<template>
	<div
		class="g-block-body-bar-panel g-block-body-padding"
		:class="{
			'g-block-body-bar-panel--edit': editable,
			'is-active': editable && active,
			'g-block-body-bar-panel--h5': h5,
			'g-block-body-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-body-bar-panel__panel" :style="{ background: panelBackground }">
			<span
				class="g-block-body-bar-panel__bar"
				:style="{ background: themeColor }"
				aria-hidden="true"
			></span>
			<div class="g-block-body-bar-panel__main">
				<RichTextEditable
					v-if="editable"
					class="g-block-body-bar-panel__title"
					fit-content
					:style="{ color: themeColor }"
					:model-value="data.title"
					placeholder="请输入标题"
					@update:model-value="onTitleUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-body-bar-panel__title"
					:style="{ color: themeColor }"
					v-html="data.title || ''"
				></div>
				<RichTextEditable
					v-if="editable"
					class="g-block-body-bar-panel__text"
					:model-value="data.content"
					placeholder="请输入正文"
					@update:model-value="onContentUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-body-bar-panel__text"
					v-html="data.content || ''"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { lightenHexColor } from '../../../utils/richText.js';
	import { bodyCardMixin } from '../shared/bodyCardMixin.js';

	export default {
		name: 'GBlockBodyBarPanel',
		components: { RichTextEditable },
		mixins: [bodyCardMixin],
		computed: {
			panelBackground() {
				return lightenHexColor(this.themeColor, 0.93);
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../shared/bodyEditShell.less';

	.g-block-body-bar-panel {
		.body-block-edit-shell();
	}

	.g-block-body-bar-panel__panel {
		display: flex;
		overflow: hidden;
	}

	.g-block-body-bar-panel__bar {
		width: 4px;
		flex-shrink: 0;
	}

	.g-block-body-bar-panel__main {
		flex: 1;
		min-width: 0;
		padding: 12px 14px;
	}

	.g-block-body-bar-panel__title {
		.body-title-base();
		margin-bottom: 8px;
		font-weight: 700;
	}

	.g-block-body-bar-panel__text {
		.body-text-base();
		color: #666;
	}

	.g-block-body-bar-panel--h5 {
		.g-block-body-bar-panel__bar { width: 0.08rem; }
		.g-block-body-bar-panel__main { padding: 0.24rem 0.28rem; }
		.g-block-body-bar-panel__title { margin-bottom: 0.16rem; }
		.body-title-base--h5(~'.g-block-body-bar-panel__title');
		.body-text-base--h5(~'.g-block-body-bar-panel__text');
	}
</style>
